import { Input } from '@/ui/base/input';
import { Label } from '@/ui/base/label';
import { cn } from '@/nucleo/utilitarios';

interface DateRangeFilterProps {
  /** Data inicial, no formato ISO (yyyy-mm-dd). Vazio = sem limite. */
  from: string;
  /** Data final, no formato ISO. */
  to: string;
  onChange: (intervalo: { from: string; to: string }) => void;
  label?: string;
  className?: string;
}

/**
 * Filtro por periodo — de uma data a outra. Cada campo tem rotulo proprio, e a
 * data final nunca pode ser anterior a inicial (o proprio campo impede, pelo
 * atributo min/max).
 */
export function DateRangeFilter({
  from,
  to,
  onChange,
  label = 'Período',
  className,
}: DateRangeFilterProps) {
  return (
    // `<div>`, não `<fieldset>/<legend>`: mesmo com padding/borda zerados, a
    // renderização de `<legend>` varia entre navegadores o bastante pra
    // ficar visivelmente deslocada de um `<Label>` comum ao lado, num grid
    // de colunas (achado real, comparado lado a lado com a coluna "DRE").
    // Mesma estrutura dela (`space-y-1` + `Label`) — só o rótulo do grupo
    // deixa de ser semanticamente um `<legend>`; cada campo continua com o
    // próprio rótulo (`sr-only`, abaixo).
    <div className={cn('space-y-1', className)}>
      <Label className="text-muted-foreground text-xs uppercase tracking-wider">{label}</Label>
      <div className="flex items-end gap-2">
        <div className="flex flex-col gap-1">
          <Label htmlFor="periodo-de" className="sr-only">
            Data inicial
          </Label>
          <Input
            id="periodo-de"
            type="date"
            value={from}
            max={to || undefined}
            onChange={(e) => onChange({ from: e.target.value, to })}
            className="w-38"
          />
        </div>
        <span className="text-muted-foreground pb-2 text-sm" aria-hidden="true">
          até
        </span>
        <div className="flex flex-col gap-1">
          <Label htmlFor="periodo-ate" className="sr-only">
            Data final
          </Label>
          <Input
            id="periodo-ate"
            type="date"
            value={to}
            min={from || undefined}
            onChange={(e) => onChange({ from, to: e.target.value })}
            className="w-38"
          />
        </div>
      </div>
    </div>
  );
}
